import { setConnectionStatus } from "../Components/WebChat/Common/FileUploadValidation";
import { unreadCountConstruction } from "../initial/initialization";
import { updateconnStatus } from "../Redux/feature/connectionStatusSlice";
import { updateReconnectData } from "../Redux/feature/recentChatDataSlice";
import { store } from "../Redux/store";
import SDK from "../SDK";
import { arrayToObject, formatUserIdToJid, getLastMsgFromHistoryById, getRecentChatData, handleUserSettings, isActiveConversationUserOrGroup, isGroupChat } from "./Chat/ChatHelper";
import { CHAT_TYPE_GROUP, CONNECTION_STATE_CONNECTING } from "./Chat/Constant";
import { encryptAndStoreInLocalStorage, getFromLocalStorageAndDecrypt } from "./Chat/webChatEncryptDecrypt";
import { isAppOnline } from "./Utility";
import { clearChatHistoryAction, reconnectChatMessages, ReconnectUpdateChatHistory } from "../Redux/feature/chatConversationHistorySlice"
import { addGroupsData } from "../Redux/feature/groupsDataSlice";
import { RECONNECT_GET_CHAT_LIMIT } from "./Constants";
import { getIdFromJid, isLocalUser } from "./Chat/User";
import { addGroupMembersData } from "../Redux/feature/groupMembersDataSlice";
import { formatToArrayofJid, setContactWhoBlockedMe } from "./Chat/BlockContact";
import { addBlockedContact } from "../Redux/feature/blockContactSlice";

export const reconnect=()=> {
    encryptAndStoreInLocalStorage("connection_status", CONNECTION_STATE_CONNECTING);
    setConnectionStatus(CONNECTION_STATE_CONNECTING);
    store.dispatch(updateconnStatus(CONNECTION_STATE_CONNECTING));
    isAppOnline() && login();
  }
  
  const handleChatHistoryUpdate = (recentChatArr, oldRecentChatData) => {
    const { chatConversationHistory: { data } = {} } = store.getState();
    const chatHistoryIds = Object.keys(data);
    const recentChatArrNew = recentChatArr.reverse();
    const oldRecentChatObj = arrayToObject(oldRecentChatData, "fromUserId");
  
    for (const element of recentChatArrNew) {
      const newRecentChat = element;
      const { fromUserId: chatId, msgId: recentMsgId, chatType } = newRecentChat;
      const oldRecentChat = oldRecentChatObj[chatId];
  
      if (chatHistoryIds.includes(chatId)) {
        const { msgId: lastMsgId, rowId } = getLastMsgFromHistoryById(chatId);
        const isRefreshNeeded = checkIfConversationRefreshNeeded(newRecentChat, oldRecentChat);
        
        // If Message Status Changed - Refresh Conversation History
        if (isRefreshNeeded) {
          getAndUpdateChatMessages(chatId, chatType);
        }
  
        if (recentMsgId !== lastMsgId) {
          // When there is no message, the position fetching should be 'UP'
          // Because no message in current conversation screen. So we should
          // get the recent messages only. Otherwise 'DOWN'
          getAndUpdateChatMessages(chatId, chatType, rowId);
        } else {
          break;
        }
      }
    }
    /**
    for (let i = 0; i < recentChatArrNew.length; i++) {
      const newRecentChat = recentChatArrNew[i];
      const { fromUserId: chatId, msgId: recentMsgId, chatType } = newRecentChat;
      const oldRecentChat = oldRecentChatObj[chatId];
  
      if (chatHistoryIds.includes(chatId)) {
        const { msgId: lastMsgId, rowId } = getLastMsgFromHistoryById(chatId);
        const isRefreshNeeded = checkIfConversationRefreshNeeded(newRecentChat, oldRecentChat);
        
        // If Message Status Changed - Refresh Conversation History
        if (isRefreshNeeded) {
          getAndUpdateChatMessages(chatId, chatType);
        }
  
        if (recentMsgId !== lastMsgId) {
          // When there is no message, the position fetching should be 'UP'
          // Because no message in current conversation screen. So we should
          // get the recent messages only. Otherwise 'DOWN'
          getAndUpdateChatMessages(chatId, chatType, rowId);
        } else {
          break;
        }
      }
    }
     */
  };

  export const handleBlockMethods = async () => {
    const userIBlockedRes = await SDK.getUsersIBlocked();
    if (userIBlockedRes && userIBlockedRes.statusCode === 200) {
      const jidArr = formatToArrayofJid(userIBlockedRes.data);
      store.dispatch(addBlockedContact(jidArr));
    }
  
    const userBlockedMeRes = await SDK.getUsersWhoBlockedMe();
    if (userBlockedMeRes && userBlockedMeRes.statusCode === 200) {
      const jidArr = formatToArrayofJid(userBlockedMeRes.data);
      setContactWhoBlockedMe(jidArr);
    }
  };

  const getAndUpdateChatMessages = async (chatId, chatType, rowId) => {
    let position = rowId ? "down" : "up";
    const chatMessageRes = await SDK.getChatMessages(
      formatUserIdToJid(chatId, chatType),
      position,
      rowId,
      RECONNECT_GET_CHAT_LIMIT,
      false
    );
  
    if (chatMessageRes && chatMessageRes.statusCode === 200) {
      chatMessageRes.chatType = chatType;
      delete chatMessageRes.statusCode;
      delete chatMessageRes.message;
      if (chatId === getIdFromJid(chatMessageRes.userJid || chatMessageRes.groupJid)) {
        store.dispatch(reconnectChatMessages(chatMessageRes));
        const groupId = isGroupChat(chatType) ? chatId : "";
        chatMessageRes.data.map((el) => {
          if (!isLocalUser(el.publisherId) && el.rowId !== rowId) {
            if (isActiveConversationUserOrGroup(chatId)) {
              SDK.sendSeenStatus(formatUserIdToJid(el.publisherId), el.msgId, groupId);
            } else {
              // // store.dispatch(chatSeenPendingMsg(el));
            }
          }
        });
      }
    }
  };

  const checkIfConversationRefreshNeeded = (newRecent, oldRecent) => {
    const { msgStatus: newMsgStatus } = newRecent;
    const { msgStatus: oldMsgStatus } = oldRecent;
    return newMsgStatus !== oldMsgStatus;
  };

  const handleClearChat = (recentChat)=>{
    recentChat.map((recent)=>{
      if(Object.keys(recent.msgBody).length === 0 && recent.msgType !== "groupProfileUpdated"){
        store.dispatch(clearChatHistoryAction(recent.fromUserId))
      }
    })
  }

  export async function login() {
    try {
      if (getFromLocalStorageAndDecrypt("auth_user")) {
        let decryptResponse = getFromLocalStorageAndDecrypt("auth_user");
        
        const loginResult = await SDK.connect(decryptResponse.username, decryptResponse.password, true);
        console.log("Reconnect loginResult :>> ", loginResult);
        if (loginResult.statusCode === 200) {
          await SDK.getUserProfile(formatUserIdToJid(decryptResponse.username));
          // // await SDK.getFriendsList();
          const groupListRes = await SDK.getGroupsList();
          if (groupListRes && groupListRes.statusCode === 200) {
            store.dispatch(addGroupsData(groupListRes.data));
          }
          /**
          // const { data = [] } = groupListRes 
          //   data.map(item=>{
          //     if( isActiveConversationUserOrGroup(item?.groupId) && item?.isAdminBlocked){
          //       Store.dispatch(ActiveChatResetAction());
          //       toast.info("This group is no longer available")
          //       Store.dispatch(hideModal())
          //     }  
          //   }
          //   )
          */
          const oldRecentChatData = getRecentChatData();
          const recentChatsRes = await SDK.getRecentChats();
          let recentChatArr = [];
          if (recentChatsRes && recentChatsRes.statusCode === 200) {
            recentChatArr = recentChatsRes.data;
            store.dispatch(updateReconnectData(recentChatsRes.data, true));
            unreadCountConstruction(recentChatsRes.data)
          }
          handleUserSettings();
          handleClearChat(recentChatArr)
          store.getState()?.activeChatData?.data.length !==0 && updateActiveChatHistory(recentChatsRes.data);
          sendSeenStatus();
          handleChatHistoryUpdate(recentChatArr, oldRecentChatData);
          /**
          // handleArchivedChats();
          // handleBlockMethods();
          // handleFavouriteMessages();
          */
        }
        }
    } catch (error) {
      console.log("reconnect error :>> ", error);
    }
  }

  const sendSeenStatus = () => {
      const { offlinePendingStatus:{ data:offlineDataArray = [] } } = store.getState()
      Promise.all(offlineDataArray.map(async(ele)=>{
                const userId = ele.chatType === 'groupchat' ? ele.publisherId : ele?.fromUserJid
                const groupId = ele.chatType === 'groupchat' ?   ele?.fromUserJid : "" 
                await SDK.sendSeenStatus(formatUserIdToJid(userId),ele.msgId,groupId)
        }))
  }

  const updateActiveChatHistory = async(updatedRecentChats) => {
    const activeChatData = store.getState()?.activeChatData?.data[0]
    const { chatId:activeChatId,chatType:activeChatType } = activeChatData
    const activeRecentChatData = updatedRecentChats.filter(ele=>ele.fromUserId === activeChatId)
    const chatMessageRes = await SDK.getChatMessages(formatUserIdToJid(activeChatId,activeChatType), null, null, activeRecentChatData[0]?.unreadCount);
    if(activeChatType === CHAT_TYPE_GROUP){
      const groupPartRes = await SDK.getGroupParticipants(formatUserIdToJid(activeChatId,activeChatType));
      if (groupPartRes && groupPartRes.statusCode === 200) {
        setTimeout(()=>(
          store.dispatch(addGroupMembersData(groupPartRes.data))
        ),1000) 
      }
    }
    // const activeChatWebHistory = store.getState()?.chatConversationHistory?.data[activeChatId]?.messages
    chatMessageRes.data.map(ele=>{
      setTimeout(()=>(
        store.dispatch(ReconnectUpdateChatHistory(ele))
      ),500)  
    })

  }
  